<script setup lang="ts">
import { computed } from "vue";

interface Props {
    // biome-ignore lint/suspicious/noExplicitAny: Init Biome
    errors: any[];
}

const props = defineProps<Props>();

// biome-ignore lint/suspicious/noExplicitAny: Init Biome
const displayableErrors = computed(() => props.errors.filter((error: any) => error && Object.keys(error).length));
</script>

<template>
    <div class="GlobalErrors" v-if="errors?.length">
        <error v-for="(error, index) in displayableErrors" :error="error" :key="index" />
    </div>
</template>

<style lang="scss">
.GlobalErrors {
    .error {
        color: $red;
    }
}
</style>
